import Vue from 'vue'

export default {

    /**
     * Update notifications
     * @param state
     * @constructor
     */
    UPDATE_TASKS_NOTIFICATIONS(state)
    {
        // Init aggr
        let aggr = {};

        // Add notification
        let addNotification = function(id, zone, type, external, count, info)
        {
            // Create new if absent
            if(aggr[id] === undefined) aggr[id] = {};

            // Create new if absent
            if(aggr[id][zone] === undefined) aggr[id][zone] = {};

            // Create new if absent
            if(aggr[id][zone][type] === undefined) aggr[id][zone][type] = {};

            // Create new if absent
            if(aggr[id][zone][type][external] === undefined) aggr[id][zone][type][external] = {count: 0, info: false};

            // Add statistics
            aggr[id][zone][type][external]['count'] += count;
            if(info) aggr[id][zone][type][external]['info'] = info;
        };

        // Process notifications
        Object.values(state.notifications).forEach(n => {

            // Unpack parents
            if(n.parents) n.parents.split(",").forEach(p =>
            {
                // Add task notifications
                //global[p] = (global[p] ? global[p] : 0) + 1;
                addNotification(p, "global", n.action_type, n.external_id,1, n.info);
            });

            // Add local notification
            addNotification(n.source_id,"local", n.action_type, n.external_id, 1, n.info);
        });

        // Store result
        state.aggregate = aggr;

    },

    /**
     * Set tasks
     * @param state
     * @param notifications
     * @constructor
     */
    SET_NOTIFICATIONS(state, notifications) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(notifications)) notifications = [notifications];

        // Save each task from list to state
        notifications.forEach(i => {

            // Check is task deleted
            if(i.deleted_at)
            {
                // Delete task
                Vue.delete(state.notifications, i.id);
            }
            else {

                // Add zero notification
                i.parents += ",0";

                // Store task
                Vue.set(state.notifications, i.id, i);
            }
        });

        // Update tree statuses
        this.commit('notifications/UPDATE_TASKS_NOTIFICATIONS');

    },

    /**
     * Delete notifications
     * @param state
     * @param notifications
     * @constructor
     */
    DELETE_NOTIFICATIONS(state, notifications) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(notifications)) notifications = [notifications];

        // Save each task from list to state
        notifications.forEach(i => {
            Vue.delete(state.notifications, i.id);
        });

        // Update tree statuses
        this.commit('notifications/UPDATE_TASKS_NOTIFICATIONS');

    },

    SET_NOTIFICATION_SETTINGS_LIST(state, payload) {
        Vue.set(state, 'notificationSettings', payload.list)
    }
}
